'use client';

import React from 'react';

export interface StatusPillProps {
  status?: 'confirmed' | 'pending' | 'cancelled' | 'completed' | 'noshow';
  style?: React.CSSProperties;
}

/** Appointment status pill — color + dot + Hebrew label (never color alone). */
export function StatusPill({ status = 'pending', style = {} }: StatusPillProps) {
  const map = {
    confirmed: { label: 'מאושר', tone: 'var(--success)', wash: 'var(--success-wash)' },
    pending: { label: 'ממתין', tone: 'var(--warn)', wash: 'var(--warn-wash)' },
    cancelled: { label: 'בוטל', tone: 'var(--error)', wash: 'var(--error-wash)' },
    completed: { label: 'הושלם', tone: 'var(--info)', wash: 'var(--info-wash)' },
    noshow: { label: 'לא הגיע', tone: 'var(--text-tertiary)', wash: 'var(--bg-sunken)' },
  }[status];

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 'var(--sp-2)',
        height: 24,
        paddingInline: 'var(--sp-3)',
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--fs-micro)',
        fontWeight: 'var(--fw-semibold)' as React.CSSProperties['fontWeight'],
        color: map.tone,
        background: map.wash,
        borderRadius: 'var(--r-full)',
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      <span
        style={{
          width: 6,
          height: 6,
          borderRadius: 'var(--r-full)',
          background: map.tone,
          flex: '0 0 auto',
        }}
      />
      {map.label}
    </span>
  );
}
